import { RegisterForm } from '@features/auth';
import { AuthLayout } from '@widgets/auth-layout';

export function RegisterPage() {
  return (
    <AuthLayout>
      <RegisterForm />
    </AuthLayout>
  );
}
